import {
  getCurrentUser,
  getRefreshToken,
  getToken,
  isAuthenticated
} from '@/services/auth.service';
import {
  REFRESH_TOKEN,
  SIGN_IN_FAILURE,
  SIGN_IN_SUCCESS,
  SIGN_OUT_FAILURE,
  SIGN_OUT_SUCCESS,
  REFRESH_REFRESHTOKEN,
  SIGN_IN_LOADING
} from '../Types/authTypes';

// import jwtDecode from 'jwt-decode';

const initState = {
  currentUser: getCurrentUser(),
  token: getToken(),
  error: '',
  loading: false,
  isAuthenticated: isAuthenticated(),
  refreshToken: getRefreshToken()
};

const authenticationReducer = function (state = initState, action) {
  switch (action.type) {
    case SIGN_IN_LOADING:
      return {
        ...state,
        loading: true,
        currentUser: null,
        isAuthenticated: false
      };
    case SIGN_IN_FAILURE:
    case SIGN_OUT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        currentUser: null,
        isAuthenticated: false
      };
    case SIGN_IN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        token: action.payload.token,
        currentUser: action.payload.user,
        error: null
      };
    case SIGN_OUT_SUCCESS:
      localStorage.removeItem('accessToken');
      return {
        ...state,
        isAuthenticated: false,
        loading: false,
        currentUser: null,
        token: '',
        refreshToken: ''
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        token: action.payload
      };
    case REFRESH_REFRESHTOKEN:
      return {
        ...state,
        refreshToken: action.payload
      };

    default:
      return { ...state };
  }
};

export default authenticationReducer;
